export enum RouteName {
  ApiKeys = 'api-keys',
  Login = 'login',
  Register = 'register',
  OAuthIdentityCallback = 'oauth-identity-callback',
  OAuthAppConsent = 'oauth-app-consent',
  ConnectionAuthCallback = 'connection-auth-callback',
  WorkspaceSettings = 'workspace-settings',
  WorkspaceActivityLog = 'workspace-activity-log',
  WorkspaceTrash = 'workspace-trash',
  WorkspacePermissions = 'workspace-permissions',
  WorkspaceMembers = 'workspace-members',
  WorkspaceHome = 'workspace-home',
  WorkspaceResources = 'workspace-resources',
  WorkspaceResourceCollection = 'workspace-resource-collection',
  Collections = 'collections',
  Collection = 'collection',
  CollectionRecents = 'collection-recents',
  WorkspaceInvitations = 'workspace-invitations',
  Database = 'database',
  DatabaseView = 'DatabaseView',
  WorkspaceGroups = 'workspace-groups',
  WorkspaceWebhooks = 'workspace-webhooks',
  WorkspaceNotificationSettings = 'workspace-notification-settings',
  WorkspaceWatcherSettings = 'workspace-watcher-settings',
  WorkspaceUsage = 'workspace-usage',
  WorkspaceBillingUsage = 'workspace-billing-usage',
  WorkspaceBillingBudgetsAndAlerts = 'workspace-billing-budgets-and-alerts',
  WorkspaceBillingInvoices = 'workspace-billing-invoices',
  WorkspaceBillingPayments = 'workspace-billing-payments',
  WorkspaceBillingPaymentMethods = 'workspace-billing-payment-methods',
  WorkspaceInvoiceFile = 'workspace-invoice-file',
  DatabaseSettings = 'database-settings',
  DatabaseActivityLog = 'database-activity-log',
  DatabaseNotificationSettings = 'database-notification-settings',
  DatabaseWatcherSettings = 'database-watcher-settings',
  DatabasePermissions = 'database-permissions',
  DatabaseWebhooks = 'database-webhooks',
  DatabaseTrash = 'database-trash',
  Automations = 'automations',
  DatabasePropertySettings = 'database-property-settings',
  DatabasePropertyPermissions = 'database-property-permissions',
  DatabasePropertyWebhooks = 'database-property-webhooks',
  Settings = 'settings',
  Connection = 'connection',
  AppearanceSettings = 'appearance-settings',
  DesktopAppSettings = 'desktop-app-settings',
  ColorsComparison = 'colors-comparison',
  VerifyMailAddress = 'verify-mail-address',
  VerifyMailChange = 'verify-mail-change',
  VerifyPasswordChange = 'verify-password-change',
  ChooseWorkspace = 'choose-workspace',
  Logout = 'logout',
  CreateWorkspace = 'create-workspace',
  Invitation = 'invitation',
  NotFound = 'not-found',
  AccountSecuritySettings = 'account-security-settings',
  TwoFactorLogin = 'two-factor-login',
  ForgotPassword = 'forgot-password',
  DatabaseItemFile = 'database-item-file',
  ResetPassword = 'reset-password',
  DatabasePropertyActivityLog = 'database-property-activity-log',
  DatabaseLinks = 'database-links',
  DatabaseViewSettings = 'database-view-settings',
  DatabaseViewActivityLog = 'database-view-activity-log',
  DatabaseViewPermissions = 'database-view-permissions',
  DatabaseViewLinks = 'database-view-links',
  DatabaseSliceSettings = 'database-slice-settings',
  DatabaseSliceActivityLog = 'database-slice-activity-log',
  DatabaseSlicePermissions = 'database-slice-permissions',
  DatabaseSliceLinks = 'database-slice-links',
  Conversation = 'conversation',
  ConversationSettings = 'conversation-settings',
  ConversationNotificationSettings = 'conversation-notification-settings',
  ConversationWatcherSettings = 'conversation-watcher-settings',
  ConversationPermissions = 'conversation-permissions',
  ConversationFile = 'conversation-file',
  Dashboard = 'dashboard',
  DashboardSettings = 'dashboard-settings',
  DashboardPermissions = 'dashboard-permissions',
  CallRoom = 'call',
  CallSettings = 'call-settings',
  CallPermissions = 'call-permissions',
  Automation = 'automation',
  Folder = 'folder',
  AutomationSettings = 'automation-settings',
  AutomationPermissions = 'automation-permissions',
  FolderSettings = 'folder-settings',
  FolderWebhooks = 'folder-webhooks',
  FolderNotificationSettings = 'folder-notification-settings',
  FolderWatcherSettings = 'folder-watcher-settings',
  FolderPermissions = 'folder-permissions',
  CloudCatalog = 'cloud-catalog',
  CloudFile = 'cloud-file',
  DatabaseItem = 'database-item',
  DatabaseSlice = 'database-slice',
  DatabaseCellCommentFile = 'database-cell-comment-file',
  CloudItemCommentFile = 'cloud-item-comment-file',
  DatabaseItemFileCommentFile = 'database-item-file-comment-file',
  WorkspaceUpgradePage = 'workspace-upgrade-page',
  WorkspaceCheckout = 'workspace-checkout',
  WorkspaceExportTemplate = 'workspace-export-template',
  DirectConversation = 'direct-conversation',
  NewDirectConversation = 'new-direct-conversation',
  DirectConversationFile = 'direct-conversation-file',
  DirectConversationSettings = 'direct-conversation-settings',
  Apps = 'apps',
  AppApplication = 'app-application',
  AppItems = 'app-items',
  AppConnections = 'app-connections',
  AppWebhooks = 'app-webhooks',
  AppDynamicFields = 'app-dynamic-fields',
  AppCode = 'app-code',
  AppApiKeys = 'app-api-keys',
  Crons = 'crons',
  Connections = 'connections',
  WebhookListeners = 'webhook-listeners',
  UserExperimentalFlagSettings = 'user-experimental-flag-settings',
  AiToolPermissionsSettings = 'ai-tool-permissions-settings',
  AdminDeveloperSettings = 'admin-developer-settings',
  UserSessions = 'user-sessions',
  UserAuthorizedApps = 'user-authorized-apps',
  MyTimeTrackerSettings = 'my-time-tracker-settings',
  NotificationsSettings = 'notifications-settings',
  Notifications = 'notifications',
  Notification = 'notification',
  Document = 'document',
  DocumentSettings = 'document-settings',
  DocumentPermissions = 'document-permissions',
  DocumentNotificationSettings = 'document-notification-settings',
  DocumentWatcherSettings = 'document-watcher-settings',
  DocumentActivityLog = 'document-activity-log',
  DocumentWebhooks = 'document-webhooks',
  Whiteboard = 'whiteboard',
  WhiteboardSettings = 'whiteboard-settings',
  WhiteboardPermissions = 'whiteboard-permissions',
  WhiteboardNotificationSettings = 'whiteboard-notification-settings',
  WhiteboardWatcherSettings = 'whiteboard-watcher-settings',
  WhiteboardActivityLog = 'whiteboard-activity-log',
  WhiteboardWebhooks = 'whiteboard-webhooks',
  Skill = 'skill',
  SkillSettings = 'skill-settings',
  SkillPermissions = 'skill-permissions',
  Agent = 'agent',
  AgentSettings = 'agent-settings',
  AgentPermissions = 'agent-permissions',
  AgentNotificationSettings = 'agent-notification-settings',
  AgentWatcherSettings = 'agent-watcher-settings',
  AgentActivityLog = 'agent-activity-log',
  AgentWebhooks = 'agent-webhooks',
  WorkspaceTemplates = 'workspace-templates',
  Android = 'android',
  AutomationRunDetails = 'automation-run-details',
  ShareLinkDatabaseItemFile = 'share-link-database-item-file',
  Onboarding = 'onboarding',
  WorkspaceInstalledApps = 'workspace-installed-apps',
  WorkspacePermissionRequests = 'workspace-permission-requests',
  UserPermissionRequests = 'user-permission-requests',
  Support = 'support',
  SupportTickets = 'support-tickets',
  Changelog = 'changelog',
  UpcomingFeatures = 'upcoming-features',
}

